import { useState } from 'react';

import { HorizontalContainer, VerticalContainer } from '@american-autonomy/ag-ui';

import AirportWeatherReadout from 'components/airspace/AirportWeatherReadout';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const WeatherStrip: FunctionComponent<Props> = ({ className = '', testId = TEST_ID, weather }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    if (weather?.droneWeather === null || weather?.droneWeather === undefined) {
        return null;
    }

    const toggleLabel = isExpanded ? 'Less' : 'More';
    const handleToggle = () => setIsExpanded(current => !current);

    return (
        <VerticalContainer className={`${styles.strip} ${className}`} testId={testId}>
            <HorizontalContainer className={styles.stripRow}>
                <AirportWeatherReadout isExpanded={isExpanded} weather={weather} />

                <button className={styles.toggleButton} onClick={handleToggle} type='button'>
                    {toggleLabel}
                </button>
            </HorizontalContainer>
        </VerticalContainer>
    );
};

export default WeatherStrip;
